import { Backend, Frontend } from "shared-types";
import axios from "../utils/axios";
import url from "../utils/urls";

export const all = async (): Promise<Backend.T_Genre[]> => {
    const response: Frontend.T_Response<{ genres: Backend.T_Genre[] }> = await axios.get(url.genre.all);
    if (response.status === 200) return response.data.data.genres;
    else return [];
}

export const getTopGenre = async (): Promise<Backend.T_Genre[]> => {
    const response: Frontend.T_Response<{ genres: Backend.T_Genre[] }> = await axios.get(url.genre.topGenre);
    if (response.status === 200) return response.data.data.genres;
    else return [];
}

export const getTopSubGenre = async (id: number): Promise<Backend.T_Genre[]> => {
    const response: Frontend.T_Response<{ genres: Backend.T_Genre[] }> = await axios.get(`${url.genre.topsubGenre}/${id}`);
    if (response.status === 200) return response.data.data.genres;
    else return [];
}
